import React, { useState, useEffect } from "react";
import { useApiFetch } from "../utils/apiFetch";

function InputBienesAutocomplete({
    idSeleccionado,
    setIdSeleccionado,
    label = "Bien",
    placeholder = "Ingrese serie del bien",
    title = "Escriba la serie para buscar",
    readOnly = false,
    maxLength = 30,
    resetEntrada
}) {
    const [query, setQuery] = useState("");
    const [sugerencias, setSugerencias] = useState([]);
    const [error, setError] = useState(false); // nuevo estado
    const apiFetch = useApiFetch();

    useEffect(() => {
        if (resetEntrada) {
            setQuery("");
            setIdSeleccionado(null);
            setSugerencias([]);
        }
    }, [resetEntrada, setIdSeleccionado]);

    useEffect(() => {
        if (idSeleccionado === null) {
            setQuery("");
        }
    }, [idSeleccionado]);

    useEffect(() => {
        const fetchBienes = async () => {
            if (query.length < 2 || readOnly) {
                setSugerencias([]);
                return;
            }
            if (idSeleccionado && query === idSeleccionado.toUpperCase()) {
                setSugerencias([]);
                return;
            }
            try {
                const data = await apiFetch("consultar_bienes.php", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ query })
                });
                if (data.status === "ok") {
                    setSugerencias(data.bienes);
                } else {
                    setSugerencias([]);
                }
            } catch {
                setSugerencias([]);
            }
        };
        fetchBienes();
    }, [query, readOnly]);

    return (
        <div className="autocomplete">
            <label>{label}</label>
            <input
                type="text"
                value={query}
                onChange={(e) => {
                    const valor = e.target.value.toUpperCase();
                    const filtrado = valor.replace(/[^A-Z0-9Ñ\s\-]/g, "");
                    setQuery(filtrado);

                    // Validación: si el valor original tenía caracteres inválidos
                    if (valor !== filtrado) {
                        setError(true);
                    } else {
                        setError(false);
                    }

                    // Si el input queda vacío, limpiar selección
                    if (filtrado === "") {
                        setIdSeleccionado(null);
                    }
                }}
                placeholder={placeholder}
                title={title}
                readOnly={readOnly}
                maxLength={maxLength}
                style={{ textTransform: "uppercase" }}
            />
            {error && <small className="error-text">Valor inválido</small>}

            {sugerencias.length > 0 && !readOnly && (
                <ul className="sugerencias">
                    {sugerencias.map((b, index) => (
                        <li
                            key={index}
                            onMouseDown={() => {
                                setIdSeleccionado(b.serie_bien);
                                setQuery(b.serie_bien.toUpperCase());
                                setSugerencias([]);
                            }}
                        >
                            {b.serie_bien}
                            {b.a_paterno ? ` | Usuario: ${b.a_paterno} ${b.a_materno} ${b.usuario}` : ""}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}

export default InputBienesAutocomplete;